<template>
  <MainLayout>
    <ContentPageHeader functionName="棚卸管理" pageName="棚卸カテゴリ管理" />
    
    <div class="card mb-4">
      <div class="card-body">
        <InventoryCategoryTable
          :items="tableItems"
          :columns="columns"
          @update="handleUpdate"
        />
      </div>
    </div>
    
    <template #footer-buttons>
      <div class="footer-buttons">
        <button class="btn btn-primary" @click="saveChanges">更新</button>
      </div>
    </template>
  </MainLayout>
</template>

<script>
import MainLayout from '@/components/layout/MainLayout.vue'
import ContentPageHeader from '@/components/layout/ContentPageHeader.vue'
import InventoryCategoryTable from './InventoryCategoryTable.vue'
import service from '../../services/service';
import { showLoading, hideLoading } from '@/utils/loadingEventBus';

export default {
  name: 'InventoryCategoryView',
  components: {
    MainLayout,
    ContentPageHeader,
    InventoryCategoryTable
  },
  data() {
    return {
      categories: [],
      columns: [
        { key: 'parentCategory', label: '親カテゴリ', minWidth: 200 },
        { key: 'childCategory', label: '子カテゴリ', minWidth: 200 },
        { key: 'operation', label: '操作', minWidth: 150 }
      ]
    }
  },
  computed: {
    // 一覧テーブルに表示するカテゴリ情報
    tableItems() {
      const items = [];
      
      this.categories.forEach(parent => {
        let isFirstChild = true;
        
        parent.childCategories.forEach(child => {
          items.push({
            parentCategory: isFirstChild ? parent.categoryType : '',
            originalParent: parent.categoryType,
            childCategory: child.category,
            childId: child.id,
            isInventory: child.isInventory,
            isFirstInGroup: isFirstChild,
            childrenCount: parent.childCategories.length
          });
          isFirstChild = false;
        });
      });
      
      return items;
    }
  },
  async mounted() {
    await this.fetchData()
  },
  methods: {
    // カテゴリ一覧取得
    async fetchData() {
      try {
        showLoading();
        const response = await service.getCategoryList();
        
        if (!response || !response.data) {
          throw new Error('カテゴリ一覧の取得に失敗しました');
        }
        
        this.categories = response.data.categories;
      } catch (error) {
        console.error('カテゴリ一覧の取得に失敗しました', error);
        alert('カテゴリ一覧の取得中にエラーが発生しました。');
      } finally {
        hideLoading();
      }
    },
    // ラジオボタンアクション
    handleUpdate(childId, isInventory) {
      const category = this.findChildCategory(childId);
      if (category) {
        category.isInventory = isInventory;
      }
    },
    findChildCategory(childId) {
      for (const parent of this.categories) {
        const child = parent.childCategories.find(c => c.id === childId);
        if (child) return child;
      }
      return null;
    },
    // 更新ボタンアクション
    async saveChanges() {
      if (!confirm('棚卸カテゴリ情報を更新します。\nよろしいですか？')) {
        return;
      }
      
      try {
        showLoading();
        
        const updateData = [];
        this.categories.forEach(parent => {
          parent.childCategories.forEach(child => {
            updateData.push({
              id: child.id,
              isInventory: child.isInventory
            });
          });
        });
        const response = await service.updateInventoryCategory(updateData);
        
        if (response.data.success) {
          alert('棚卸カテゴリの更新が完了しました。');
        } else {
          throw new Error(response.data.message);
        }
      } catch (error) {
        console.error('棚卸カテゴリの更新に失敗しました。', error);
        alert('棚卸カテゴリの更新中にエラーが発生しました。');
      } finally {
        hideLoading();
      }
    }
  }
}
</script>

<style scoped>
</style>
